import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthPayloadTicket, AuthorizationData, TransactionAuthorizationResult } from '@zero/shared/util-models';
import { CustomerAddressData } from '../../entities/customer-address-data.model';
import { KryptoOnboardingStatusData } from '../../entities/krypto-onboarding-status-data.model';

export const cryptoOnboardingActions = createActionGroup({
  source: 'Crypto onboarding',
  events: {
    'load status': emptyProps(),
    'accept conditions': emptyProps(),
    'load customer address': emptyProps(),
    'confirm address': emptyProps(),
    'reset address confirmation date': emptyProps(),
    'accept contract': emptyProps(),
    'set data to authorize': props<{ dataToAuthorize: AuthorizationData<AuthPayloadTicket> | null }>(),
    'handle authentication result': props<{ result: TransactionAuthorizationResult }>(),
  },
});

export const cryptoOnboardingApiActions = createActionGroup({
  source: 'Crypto onboarding API',
  events: {
    'load status success': props<{ status: KryptoOnboardingStatusData }>(),
    'load status failure': props<{ error: HttpErrorResponse }>(),
    'accept conditions success': props<{ status: KryptoOnboardingStatusData }>(),
    'accept conditions failure': props<{ error: HttpErrorResponse }>(),
    'load customer address success': props<{ address: CustomerAddressData }>(),
    'load customer address failure': props<{ error: HttpErrorResponse }>(),
  },
});
